import React from "react";
import { Box, Button, Alert } from "@mui/material";

export enum InputsType {
	IMAGE = "image",
	IMAGE_MULTIPLE = "image_multiple",
	TEXT = "text",
	TEXT_MULTILINE = "text_multiline",
	DATE = "date",
	SOCIAL_MEDIA = "social_media",
	STORY = "story",
	IMAGE_SELECT = "image_select",
	MAP = "map",
	SETTINGS = "settings"
}
export interface InputValidation {
	max?: number;
	min?: number;
}
export const inputValidation: Record<string, InputValidation> = {
	groom_name: {
		max: 12,
		min: 2
	},
	bride_name: {
		max: 12,
		min: 2
	},
	save_the_date_text: {
		max: 35
	},
	intro_text: {
		max: 220
	},
	sub_intro_text: {
		max: 30
	},
	comments_text: {
		max: 35
	},
	comments_sub_text: {
		max: 160
	},
	gift_text: {
		max: 180
	},
	wedding_location_text: {
		max: 100
	},
	conclusion_text: {
		max: 120
	}
};

export const inputLabels: Record<string, string> = {
	groom_name: "Groom's Name",
	bride_name: "Bride's Name",
	intro_text: "Intro",
	wedding_location_text: "Location",
	sub_intro_text: "Sub Intro",
	conclusion_text: "Conclusion",
	comments_text: "Comments Title",
	comments_sub_text: "Comments Sub Title"
};
export const inputLabelsAR: Record<string, string> = {
	groom_name: "اسم العريس",
	bride_name: "اسم العروس",
	intro_text: "المقدمة",
	wedding_location_text: "عنوان الحفل",
	sub_intro_text: "وصف المقدمه",
	conclusion_text: "الخاتمة",
	comments_text: "مقدمه التعليقات",
	comments_sub_text: "وصف للتعليقات"
};

export const inputsGuideText: Record<string, ((onAction: (action: string) => void) => React.ReactNode) | string> = {
	wedding_location: onAction => (
		<Box display={"flex"} flexDirection={"column"} gap={2}>
			<Alert severity="info">
				Please provide a valid Google Maps link (e.g., https://maps.app.goo.gl/ao5UWwYJ8KJsAnDS6).
			</Alert>
			<Button variant={"contained"} color={"secondary"} onClick={() => onAction("Location")}>
				Guide
			</Button>
		</Box>
	)
};

export const shouldDisableVisibilityUpdate: Record<string, boolean> = {
	groom_name: true,
	bride_name: true
};

export const getFieldMap = (invitationId: string) => {
	return {
		MAIN_IMAGE: `${invitationId}-main_image-${InputsType.IMAGE}`,
		GROOM_NAME: `${invitationId}-groom_name-${InputsType.TEXT}`,
		BRIDE_NAME: `${invitationId}-bride_name-${InputsType.TEXT}`,
		WEDDING_DATE: `${invitationId}-wedding_date-${InputsType.DATE}`,
		SOCIAL_MEDIA_1: `${invitationId}-partner_socials_1-${InputsType.SOCIAL_MEDIA}`,
		SOCIAL_MEDIA_2: `${invitationId}-partner_socials_2-${InputsType.SOCIAL_MEDIA}`,
		STORY: `${invitationId}-story-${InputsType.STORY}`,
		INTRO_TEXT: `${invitationId}-intro_text-${InputsType.TEXT_MULTILINE}`,
		GROOM_IMAGE: `${invitationId}-groom_image-${InputsType.IMAGE}`,
		BRIDE_IMAGE: `${invitationId}-bride_image-${InputsType.IMAGE}`,
		STORY_IMAGE: `${invitationId}-story_image-${InputsType.IMAGE}`,
		GALLERY: `${invitationId}-gallery-${InputsType.IMAGE_MULTIPLE}`,
		LOCATION_TEXT: `${invitationId}-wedding_location_text-${InputsType.TEXT}`,
		SAVE_THE_DATE: `${invitationId}-save_the_date_text-${InputsType.TEXT}`,
		SUB_INTRO: `${invitationId}-sub_intro_text-${InputsType.TEXT}`,
		CONCLUSION_TEXT: `${invitationId}-conclusion_text-${InputsType.TEXT_MULTILINE}`,
		COMMENTS_TEXT: `${invitationId}-comments_text-${InputsType.TEXT}`,
		COMMENTS_SUB_TEXT: `${invitationId}-comments_sub_text-${InputsType.TEXT_MULTILINE}`,
		GIFT_TEXT: `${invitationId}-gift_text-${InputsType.TEXT_MULTILINE}`,
		PARTNERS_ANIME: `${invitationId}-partners_anime-${InputsType.IMAGE_SELECT}`,
		MAP: `${invitationId}-wedding_coordinates-${InputsType.MAP}`,
		SETTINGS: `${invitationId}-settings-${InputsType.SETTINGS}`,
		THUMBNAIL_02: `${invitationId}-thumbnail_02-${InputsType.IMAGE}`
	};
};
